var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-y":"hidden"}},[_c('v-fade-transition',[(_vm.i18nLoaded)?_c('router-view'):_c('div',{staticClass:"loader-container"},[_c('h1',[_c('v-img',{attrs:{"src":require("@/assets/logo.png"),"width":"170px"}})],1)])],1),_c('ConfirmDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }